import { hashSync } from 'bcryptjs';
import { useCallback, useContext } from 'react';

import type { Salt } from '@sorare/wallet-shared';
import { MessagingContext } from '@sorare/wallet-shared';

const useHasher = () => {
  const { sendRequest } = useContext(MessagingContext)!;

  return useCallback(
    async (password: string, email?: string) => {
      if (!email) return hashSync(password, 11);

      const {
        result: { salt },
      } = await sendRequest<Salt>('salt', { email });
      return hashSync(password, salt);
    },
    [sendRequest]
  );
};

export default useHasher;
